import TableLayout from "../../../../layout/main/TableLayout";
import { Column, DText, Relative, Row } from "../../../../../styles/CommonStyles";
import CoinMarket from "../../../../common/common/CoinMarket";
import {
    TradeTypeBadge
} from "../../../../../styles/main/orders";
import DateTime from "../../../../common/utils/DateTime";
import Operation from "../../../../common/utils/Operation";
import UserLink from "../../../../common/utils/UserLink";
import useGetTableIndex from "../../../../../core/hooks/layout/useGetTableIndex";
import { cardsAttributes, } from "../../../../../core/constants/headers";
import CoinRow from "../../../../common/common/CoinRow";
import { useNavigate } from "react-router-dom";

const CardsTable = ({ data, userId }) => {

    const { data: cards } = data;
    const { cs, headers } = cardsAttributes;
    const { getTableIndex } = useGetTableIndex();
    const navigate = useNavigate()


    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
        >
            {cards?.data?.map((card, idx) => (
                <Relative
                    index={idx}
                    key={card._id}
                >
                    <Row
                        noHover
                        cs={cs}
                        index={idx}
                        key={card._id}
                    >
                        <Column>
                            {getTableIndex(idx)}
                        </Column>

                        <Column avatar>
                            <UserLink
                                _id={card.userId}
                                name={card.user?.email}
                            />
                        </Column>

                        <Column>
                            <DText main fontSize="s">
                                **** {card.lastFour}
                            </DText>
                        </Column>

                        <Column>
                            <CoinRow
                                coin={{ id: card.meta?.currency?.toLowerCase() }}
                            />
                        </Column>

                        <Column>
                            <TradeTypeBadge color="primary">
                                {card.type}
                            </TradeTypeBadge>
                        </Column>

                        <Column>
                            <DText main fontSize="s">
                                {card.provider}
                            </DText>
                        </Column>

                        <Column>
                            <TradeTypeBadge
                                color={
                                    card.status === "success"
                                        ? "success"
                                        : card.status === "pending"
                                            ? "warning"
                                            : "danger"
                                }
                            >
                                {card.status}
                            </TradeTypeBadge>
                        </Column>

                        <Column center>
                            <DateTime dt={card.createdAt} />
                        </Column>

                        <Column>
                            <Operation
                                onOptionClicked={(idx) => { if (idx === 0) navigate(`/users/${userId}/card-history/${card?._id}`) }}
                                options={['history']}
                                onDetailsClicked={() => navigate(`/reports/cards/card/${card._id}`)}
                                hasDetails
                                hasWriteAccess
                            />
                        </Column>
                    </Row>
                </Relative>
            ))}
        </TableLayout>
    );
};

export default CardsTable;